export default {"src":"/_next/static/media/spacehbit.bf9962ce.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};